import { Injectable } from "@angular/core";

import { LoginFeatureState } from "../state";

@Injectable({
	providedIn: "root",
})
export class EmailLoginSelector {
	emailLogin() {
		return (state: LoginFeatureState): string | undefined => state.loginFeature?.emailLogin.email;
	}
}
